import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Icon from '../../partials/Icon';

export default class GroupAdmin extends Component {
    state = {
        errors: '',
        message: '',
        isAttached: false
    }

    constructor(props) {
        super(props);

        this.attach = this.attach.bind(this);
        this.detach = this.detach.bind(this);
    }

    componentDidMount() {
        if (_.find(this.props.user.groups, ['id', this.props.group_id])) {
            this.setState({ isAttached: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (_.find(nextProps.user.groups, ['id', nextProps.group_id])) {
            this.setState({ isAttached: true });
        } else {
            this.setState({ isAttached: false });
        }
    }

    attach(event) {
        event.preventDefault();

        axios.post(API_URL+'/admin/groups/admins/attach', { 
            user_id: this.props.user.id,
            group_id: this.props.group_id
        })
        .then(response => {
            this.props.update();
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    detach(event) {
        event.preventDefault();

        axios.delete(API_URL+'/admin/groups/admins/detach', { params: {
            user_id: this.props.user.id,
            group_id: this.props.group_id
        }})
        .then(response => {
            this.props.update();
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    render() {
        const { user } = this.props;
        return (
            <li>
                <Errors errors={ this.state.errors } />
                <Icon icon="user" color="pink" /> 
                <Link to={ `/superadmin/admins/edit/${ user.id }` }>{ user.first_name } { user.last_name }</Link>

                { this.state.isAttached ? (
                    <a className="right" onClick={ this.detach }>Koppla från</a>
                ) : (
                    <a className="right" onClick={ this.attach }>Koppla till</a>
                ) }
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Group/GroupAdmin.js